import * as React from "react";
import {
  DateRangePickerSelect,
  DateRangePickerSelectProps,
} from "./DateRangePickerSelect";

// import styled from "styled-components";

export interface DateRangePickerHeaderProps {
  id: string;
  year: number;
  month: number;
  onMonthChange?: (month: number) => void;
  onYearChange?: (year: number) => void;
  innerRef?: React.MutableRefObject<{
    monthDropdown: DateRangePickerSelectProps<number>["innerRef"]["current"];
    yearDropdown: DateRangePickerSelectProps<string>["innerRef"]["current"];
  }>;
}

export const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const CURRENT_YEAR = new Date().getFullYear();

const YEARS = Array.from({ length: 20 }).map((n, idx) => {
  return CURRENT_YEAR - idx;
});

export const DateRangePickerHeader: React.FC<DateRangePickerHeaderProps> = ({
  id,
  year,
  month,
  onMonthChange,
  onYearChange,
  innerRef,
}) => {
  const monthDropdownRef = React.useRef<
    DateRangePickerSelectProps<number>["innerRef"]["current"]
  >(null);

  const yearDropdownRef = React.useRef<
    DateRangePickerSelectProps<string>["innerRef"]["current"]
  >(null);

  React.useImperativeHandle(innerRef, () => ({
    monthDropdown: monthDropdownRef.current,
    yearDropdown: yearDropdownRef.current,
  }));

  return (
    <header>
      <span className="sr-only" id={`${id}__heading`} aria-live="polite">
        {MONTHS[month]} {year}
      </span>
      <div className="d-flex">
        <div className="mx-n2 position-relative">
          <span className="sr-only" id={`${id}-month-label`}>
            Select a month
          </span>
          <DateRangePickerSelect
            innerRef={monthDropdownRef}
            id={`${id}-month-dropdown`}
            label={MONTHS[month]}
            selected={MONTHS[month]}
            onSelect={(month, idx) => {
              onMonthChange(idx);
            }}
            dataSource={MONTHS}
            renderOption={(month) => month}
            isActive={(value, idx) => {
              return idx === month;
            }}
            aria-labelledby={`${id}-month-label`}
          />
        </div>
        <div className="mx-n2 position-relative">
          <span className="sr-only" id={`${id}-year-label`}>
            Select a year
          </span>
          <DateRangePickerSelect
            innerRef={yearDropdownRef}
            id={`${id}-year-dropdown`}
            label={`${year}`}
            selected={year}
            onSelect={(_year, idx) => {
              onYearChange(_year);
            }}
            dataSource={YEARS}
            renderOption={(_year) => _year}
            isActive={(_year, idx) => {
              return _year === year;
            }}
            aria-labelledby={`${id}-year-label`}
          />
        </div>
      </div>
    </header>
  );
};
